import { render, staticRenderFns } from "./NotFoundScreen.vue?vue&type=template&id=62916df8&"
import script from "./NotFoundScreen.vue?vue&type=script&lang=ts&"
export * from "./NotFoundScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports